import React, { useState, useEffect } from "react";
import MainLayout from "../layout/MainLayout";
import { useParams } from "react-router-dom";
import axios from "axios";
import CommentList from "../components/CommentList";
import VoteTile from "../components/VoteTile";
import { Link } from "react-router-dom";


function DetailPage() {
  const { id, urlTitle } = useParams();

  const [documentData, setDocumentData] = useState({});

  const getDocumentDetails = async () => {
    axios
      .get("/api/v1/documents/" + id)
      .then((result) => setDocumentData(result.data))
      .catch((err) => console.log(err));
  };

  const handleVoteAction = (a) => {
    //do nothing - this is a callback from the VoteTile in case anything needs to happen at this level.
    //See SenateSideBySide as an example.
  }

  const formatText = (text, singleOrDouble) => {
    if (!text) return "";

    // Replace **bold** section numbers in EOs text
    let formatted = text.replace(/\*\*(.*?)\*\*\."(.*?)\."/g, "<strong><i>$1 - $2</i></strong><br/><br/>");

    //regular bold text
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, "<strong><i>$1</i></strong><br/><br/>");


    // Add indentation for lines starting with *
    formatted = formatted.replace(
      /(^|\n)\*(.*)/g,
      '$1<span style="margin-left: 2em; display: block;">$2</span>'
    );

    // Indent lines starting with numbers like 1., 2), 3:
    formatted = formatted.replace(
      /(^|\n)\d+[.):](.*)/g,
      '$1<span style="margin-left: 2em; display: block;">$&</span>'
    );

    // Replace newlines with <br/>
    //formatted = formatted.replace(/\n\n/g, "\n");
    if (singleOrDouble === 's') {
      formatted = formatted.replace(/\n/g, "<br/>");
    } else {
      formatted = formatted.replace(/\n/g, "<br/><br/>");
    }


    return formatted;
  };

  const [showFullText, toggleFullText] = useState();
  const [showSummary, toggleSummary] = useState();
  const [showRed, toggleRed] = useState();
  const [showBlue, toggleBlue] = useState();





  useEffect(() => {
    getDocumentDetails();
    toggleFullText(false);
    toggleSummary(true);
    toggleRed(true);
    toggleBlue(true);
  }, [])


  return (
    <MainLayout>
      <div>
        <Link to={"/Presidents/" + documentData.metaNumber + "/" + documentData.signatory + "?collectionIds=0"}>Back to List</Link>
      </div>
      <title>{documentData.title}</title>
      <h1>{documentData.subject}</h1>
      <h2>{documentData.title}</h2>
      <h4>{documentData.prettySignedDate}</h4>
      <h4>{documentData.signatory}</h4>
      <br />
      <button className="accordion color-neutral" onClick={() => toggleFullText(!showFullText)}>
        <img className={showFullText ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
        <img className={!showFullText ? "accordion-show" : "accordin-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
        <h4>Full Text</h4>
      </button>
      <div className="accordion-panel" style={{ display: showFullText ? "inherit" : "none" }}>
        {/* <div style={{ whitespace: 'pre-line', wordWrap: 'break-word', wordBreak: 'break-word' }}>{documentData.body}</div> */}
        <div dangerouslySetInnerHTML={{ __html: formatText(documentData.body, 's') }} />
      </div>

      <button className="accordion color-neutral" onClick={() => toggleSummary(!showSummary)}>
        <img className={showSummary ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
        <img className={!showSummary ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
        <h4>Summary</h4>
      </button>

      <div className="accordion-panel" style={{ display: showSummary ? "inherit" : "none" }}>
        <div
          dangerouslySetInnerHTML={{ __html: formatText(documentData.summary, 's') }}
        />
      </div>
      <button className="accordion color-conservative" onClick={() => toggleRed(!showRed)}>
        <img className={showRed ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
        <img className={!showRed ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
        <h4>Conservative Opinion</h4>
      </button>
      <div className="accordion-panel" style={{ display: showRed ? "inherit" : "none" }}>
        <div
          dangerouslySetInnerHTML={{
            __html: formatText(documentData.conservativeOpinion, 's'),
          }}
        />
      </div>
      <div>
        <button className="accordion color-liberal" onClick={() => toggleBlue(!showBlue)}>
          <img className={showBlue ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
          <img className={!showBlue ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
          <h4>Liberal Opinion</h4>
        </button>
        <div className="accordion-panel" style={{ display: showBlue ? "inherit" : "none" }}>
          <div
            dangerouslySetInnerHTML={{
              __html: formatText(documentData.liberalOpinion, 's'),
            }}
          />
        </div>
        <br /><br /><br />
      </div>

      <VoteTile collectionGroupId={1} documentId={id} documentSubject={documentData.subject} sendValueBack={(e) => handleVoteAction(e)} />

      <CommentList collectionGroupId={1} documentId={id} />
      <br />
      <br />
    </MainLayout >
  );
}

export default DetailPage;
